export const DataMutation_Shipping_SetBillingAddressesOnCart_QueryKey = {
  shippingSetBillingAddressesOnCart: (): string => {
    const queryKey = "data-mutation--shipping-set-billing-addresses-on-cart";
    return queryKey;
  },
};
